<template>
  <div id="crm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h3 class="title">Customers</h3>
        </div>
        <div class="col-xs-12 col-sm-6 text-right">
          <template v-if="loading">
            <a href="javascript:void(0);" class="btn btn-gray transparent disabled" style="position:relative" >
              <pulse-loader :color="'#757575'" :size="'5px'"></pulse-loader>
            </a>
          </template>
          <template v-else>
          <a href="javascript:void(0);" v-if="$store.getters.getPackage != 'premium'" class="btn btn-gray transparent disabled" style="position:relative" v-tooltip.top="'Unlock to PREMIUM plan'"><span class="glyphicon glyphicon-export"></span> Export <v-premium-lock></v-premium-lock></a>
          <a href="javascript:void(0);" v-else-if="$store.getters.getPackage == 'premium'" class="btn btn-gray transparent" style="position:relative" @click="exportCustomer"><span class="glyphicon glyphicon-export"></span> Export</a>
          </template>

          <a
            href="javascript:void(0);"
            class="btn btn-primary transparent"
            @click="showAdvance = !showAdvance"
          >
            Advanced search
            <i class="fas fa-angle-down" v-if="!showAdvance"></i>
            <i class="fas fa-angle-up" v-else></i>
          </a>
        </div>
      </div>
      <div v-if="showAdvance" style="border: 1px solid #eee;border-radius: 10px">
        <template v-if="$store.getters.getPackage == 'premium'">
          <div style="padding: 5px;">
            <div class="row" style="margin-top: 5px;">
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Name</label>
                <input
                  type="text"
                  placeholder="Name"
                  v-model="filter.fullname"
                  class="form-control"
                  maxlength="255"
                >
              </div>
              <div class="col-sm-2" style="margin-bottom: 10px">
                <label for>Channel</label>
                <select name="filter" class="form-control" v-model="filter.app">
                  <option value="all">All</option>
                  <option value="facebook">Facebook</option>
                  <option value="line">Line</option>
                </select>
              </div>
              <div class="col-sm-2" style="margin-bottom: 10px">
                <label for>Gender</label>
                <select name="filter" class="form-control" v-model="filter.gender">
                  <option value="all">All</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">No gender</option>
                </select>
              </div>
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Locale</label>
                <v-select
                  :options="localeOptions"
                  label="title"
                  v-model="filter.locale"
                  placeholder="Locale"
                  multiple
                >
                  <template slot="option" slot-scope="option">
                    <flag :iso="option.icon"/>
                    {{ option.title }}
                  </template>
                </v-select>
              </div>
              <div class="clearfix"></div>
              <div class="col-sm-6" style="margin-bottom: 10px">
                <div>
                  <label for>First Conversation At</label>
                </div>
                <template>
                  <span class="dashboard_datepicker">
                    <datepicker
                      v-model="filter.registerDate.start"
                      style="margin-bottom: 10px;"
                      @selected="onRegisterStartDate"
                      placeholder="From"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin: 0 10px">-</span>
                  <span class="dashboard_datepicker" style="margin-bottom: 10px;">
                    <datepicker
                      v-model="filter.registerDate.end"
                      style
                      @selected="onRegisterEndDate"
                      placeholder="To"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin-right: 10px;"></span>
                  <div class="hidden-sm hidden-md hidden-lg"></div>
                </template>
              </div>

              <div class="col-sm-6" style="margin-bottom: 10px">
                <div>
                  <label for>Last Conversation At</label>
                </div>
                <template>
                  <span class="dashboard_datepicker">
                    <datepicker
                      v-model="filter.activeDate.start"
                      style="margin-bottom: 10px;"
                      @selected="onActiveStartDate"
                      placeholder="From"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin: 0 10px">-</span>
                  <span class="dashboard_datepicker" style="margin-bottom: 10px;">
                    <datepicker
                      v-model="filter.activeDate.end"
                      style
                      @selected="onActiveEndDate"
                      placeholder="To"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin-right: 10px;"></span>
                  <div class="hidden-md hidden-lg"></div>
                </template>
              </div>
              <div class="clearfix"></div>

              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Email</label>
                <input
                  type="text"
                  placeholder="Email"
                  v-model="filter.email"
                  class="form-control"
                  maxlength="255"
                >
              </div>
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Phone No</label>
                <input
                  type="text"
                  placeholder="Phone No"
                  v-model="filter.phoneno"
                  class="form-control"
                  maxlength="255"
                >
              </div>
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Message Sent</label>
                <div
                  class="form-inline"
                  :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}"
                >
                  <select name id v-model="filter.messagesent.symbol" class="form-control">
                    <option value="g__">Greater than</option>
                    <option value="l__">Less than</option>
                    <option value="n__">Not</option>
                  </select>
                  <input
                    type="text"
                    class="form-control"
                    name="filterMessageSent"
                    data-vv-name="filterMessageSent"
                    data-vv-as="Message Sent"
                    placeholder="Value"
                    style="max-width: 150px"
                    v-model="filter.messagesent.value"
                    v-validate="'numeric'"
                  >
                  
                  <p
                    class="text-error"
                    v-if="errors.has('filterMessageSentFrom')"
                  >{{ errors.first('filterMessageSentFrom') }}</p>
                  <p
                    class="text-error"
                    v-else-if="errors.has('filterMessageSent')"
                  >{{ errors.first('filterMessageSent') }}</p>
                </div>
              </div>
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Status</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Status"
                  v-model="filter.status"
                  maxlength="255"
                >
              </div>
              <div class="col-sm-4" style="margin-bottom: 10px">
                <label for>Intent</label>
                <v-select
                  :options="filterIntent"
                  label="title"
                  v-model="filter.intent"
                  placeholder="Intent"
                  multiple
                ></v-select>
              </div>
              <div class="col-xs-12 text-right" style="margin-bottom: 10px">
                <a
                  href="javascript:void(0);"
                  class="btn btn-gray transparent"
                  @click="clearSearch"
                >Clear search</a>
                <a href="javascript:void(0);" class="btn btn-primary" @click="onSearch">
                  <i class="fas fa-search"></i> Search
                </a>
              </div>
            </div>
          </div>
        </template>

        <div style="position: relative;overflow: auto;width: 100%;" v-else>
          <v-premium-plan-popup :showAll="false" marginTop="65"></v-premium-plan-popup>

          <div>
            <div class="col-sm-4" style="margin-bottom: 10px;margin-top: 5px;">
              <label for>Name</label>
              <input type="text" placeholder="Name" class="form-control" maxlength="255">
            </div>
            <div class="col-sm-2" style="margin-bottom: 10px">
              <label for>Channel</label>
              <select name="filter" class="form-control">
                <option value="all" selected>All</option>
                <option value="facebook">Facebook</option>
                <option value="line">Line</option>
              </select>
            </div>
            <div class="col-sm-2" style="margin-bottom: 10px">
              <label for>Gender</label>
              <select name="filter" class="form-control">
                <option value="all" selected>All</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">No gender</option>
              </select>
            </div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Locale</label>
              <v-select :options="localeOptions" label="title" placeholder="Locale" multiple>
                <template slot="option" slot-scope="option">
                  <flag :iso="option.icon"/>
                  {{ option.title }}
                </template>
              </v-select>
            </div>
            <div class="clearfix"></div>
            <div class="col-sm-6" style="margin-bottom: 10px">
              <div>
                <label for>First Conversation At</label>
              </div>
              <template>
                <span class="dashboard_datepicker">
                  <datepicker
                    v-model="filter.registerDate.start"
                    style="margin-bottom: 10px;"
                    @selected="onRegisterStartDate"
                    placeholder="From"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                  ></datepicker>
                </span>
                <span class="hidden-xs" style="margin: 0 10px">-</span>
                <span class="dashboard_datepicker" style="margin-bottom: 10px;">
                  <datepicker
                    v-model="filter.registerDate.end"
                    style
                    @selected="onRegisterEndDate"
                    placeholder="To"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                  ></datepicker>
                </span>
                <span class="hidden-xs" style="margin-right: 10px;"></span>
                <div class="hidden-sm hidden-md hidden-lg"></div>
              </template>
            </div>

            <div class="col-sm-6" style="margin-bottom: 10px">
              <div>
                <label for>Last Conversation At</label>
              </div>
              <template>
                <span class="dashboard_datepicker">
                  <datepicker
                    v-model="filter.activeDate.start"
                    style="margin-bottom: 10px;"
                    placeholder="From"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                  ></datepicker>
                </span>
                <span class="hidden-xs" style="margin: 0 10px">-</span>
                <span class="dashboard_datepicker" style="margin-bottom: 10px;">
                  <datepicker
                    v-model="filter.activeDate.end"
                    style
                    placeholder="To"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                  ></datepicker>
                </span>
                <span class="hidden-xs" style="margin-right: 10px;"></span>
                <div class="hidden-md hidden-lg"></div>
              </template>
            </div>
            <div class="clearfix"></div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Email</label>
              <input type="text" placeholder="Email" class="form-control" maxlength="255">
            </div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Phone No</label>
              <input type="text" placeholder="Phone No" class="form-control" maxlength="255">
            </div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Message Sent</label>
              <div
                class="form-inline"
                :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}"
              >
                <select name id class="form-control">
                  <option value="g__" selected>Greater than</option>
                  <option value="l__">Less than</option>
                  <option value="n__">Not</option>
                </select>
                <input
                  type="text"
                  class="form-control"
                  name="filterMessageSent"
                  data-vv-name="filterMessageSent"
                  data-vv-as="Message Sent"
                  placeholder="Value"
                  style="max-width: 150px"
                  v-validate="'numeric'"
                >
                <!-- <input type="text" class="form-control" name="filterMessageSentFrom" data-vv-name="filterMessageSentFrom" data-vv-as="Message Sent From" placeholder="From" style="max-width: 150px" v-model="filter.messagesent.from" v-validate="'numeric'">
									-
                <input type="text" class="form-control" name="filterMessageSentTo" data-vv-name="filterMessageSentTo" data-vv-as="Message Sent To" placeholder="To" style="max-width: 150px" v-model="filter.messagesent.to" v-validate="'numeric'">-->
                <p
                  class="text-error"
                  v-if="errors.has('filterMessageSentFrom')"
                >{{ errors.first('filterMessageSentFrom') }}</p>
                <p
                  class="text-error"
                  v-else-if="errors.has('filterMessageSent')"
                >{{ errors.first('filterMessageSent') }}</p>
              </div>
            </div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Status</label>
              <input type="text" class="form-control" placeholder="Status" maxlength="255">
            </div>
            <div class="col-sm-4" style="margin-bottom: 10px">
              <label for>Intent</label>
              <v-select :options="filterIntent" label="title" placeholder="Intent" multiple></v-select>
            </div>
          </div>

          <div class="col-xs-12 text-right" style="margin-bottom: 10px;">
            <a href="javascript:void(0);" class="btn btn-gray transparent">Clear search</a>
            <a href="javascript:void(0);" class="btn btn-primary">
              <i class="fas fa-search"></i> Search
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="customer"
      style="background: #eee; border: 1px solid #eee; border-radius: 10px;margin: 15px;overflow:hidden"
    >
      <div style="overflow-x: auto;">
        <table class="customer-container" style="width: 100%">
          <thead>
            <tr style="border-bottom: 3px solid #eee">
              <td>Name</td>
              <td class="text-center">Channel</td>
              <td>Gender</td>
              <td>Register Date</td>
              <td>Last Active Date</td>
              <td :class="{'background-gray': $store.getters.getPackage != 'premium'}">Email</td>
              <td :class="{'background-gray': $store.getters.getPackage != 'premium'}">Phone No</td>
              <td
                :class="{'background-gray': $store.getters.getPackage != 'premium'}"
                class="text-center"
              >Status</td>
              <td
                :class="{'background-gray': $store.getters.getPackage != 'premium'}"
                class="text-center"
              >Message Sent</td>
              <td class="text-center">Locale</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <template v-if="users.length > 0">
              <customer-item
                v-for="(user, index) in users"
                :key="'user_'+ index"
                v-model="users[index]"
              ></customer-item>
            </template>
            <template v-else>
              <tr v-if="!loading">
                <td colspan="11" class="text-center">No user</td>
              </tr>
            </template>
            <template v-if="loading">
              <tr>
                <td colspan="11" class="text-center" style="padding: 10px 0px">
                  <scale-loader :color="$store.state.theme.brand_color" height="35px" width="7px"></scale-loader>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="text-center" v-if="!loading && hasNext">
      <a
        href="javascript:void(0)"
        class="btn btn-primary transparent"
        @click="getMoreCustomers"
      >Next</a>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import moment from "moment";
import datepicker from "vuejs-datepicker";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import CustomerItem from "./CustomerItem";

export default {
  data: function() {
    return {
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: "",
      users_count: [],
      intents: [],
      // users_count: this.value,
      search: "",
      filter: {
        fullname: "",
        gender: "all",
        locale: null,
        app: "all",
        intent: null,
        email: "",
        phoneno: "",
        messagesent: {
          value: null,
          symbol: "g__"
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        }
      },
      localeOptions: config.locale,
      loading: true
    };
  },
  components: {
    ScaleLoader,
    CustomerItem,
    datepicker,
    PulseLoader
  },
  mounted: function() {
    var vm = this;
    vm.getIntent(function() {
      vm.getLoadUsers(function(users) {
        vm.offset += vm.limit + 1;
        vm.users = vm.users.concat(users);
      });
    });
  },
  computed: {
    pageid: function() {
      return this.$store.state.selectedBot.pageid;
    },
    filterIntent: function() {
      var vm = this;
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase(); // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase(); // ignore upper and lowercase
        if (
          a.intentname[0] == "{" &&
          a.intentname[a.intentname.length - 1] == "}"
        ) {
          return 1;
        }
        if (
          b.intentname[0] == "{" &&
          b.intentname[b.intentname.length - 1] == "}"
        ) {
          return -1;
        }
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      var intents = [];
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname);
      });
      return intents;
    }
  },
  methods: {
    clearSearch: function() {
      this.filter = {
        fullname: "",
        gender: "all",
        locale: null,
        app: "all",
        intent: null,
        messagesent: {
          value: null,
          symbol: "g__"
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        }
      };

      this.onSearch();
    },
    onSearch: function() {
      var vm = this;
      vm.$validator.validate().then(result => {
        if (!result) {
          vm.goToErrorInput();
          return false;
        }
        vm.offset = 0;
        vm.hasNext = true;
        vm.getLoadUsers(function(users) {
          vm.users = [];
          vm.users = vm.users.concat(users);
        });
      });
    },
    getLoadUsers: function(callback) {
      let vm = this;
      let data = {
        pageid: vm.pageid,
        limit: vm.limit,
        offset: vm.offset,
        grouptype: vm.grouptype,
        filter: vm.filter
      };
      vm.loading = true;

      api.getAllUsers(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loading = false;
          callback(null);
          return;
        }
        if (vm.limit > response.data.length) {
          vm.hasNext = false;
        } else {
          // response.data.pop()
        }

        var users = response.data;

        // vm.count = response.count
        // vm.users_count.total = vm.count
        // vm.gendercount ="";
        // if(response.countmale!=null&&response.countfemale!=null){
        // 	vm.users_count.male = response.countmale
        // 	vm.users_count.female = response.countfemale
        // 	vm.gendercount =" (M:"+response.countmale+"/F:"+response.countfemale+")";

        // }

        vm.$nextTick(function() {
          vm.loading = false;
          callback(users);
        });
      });
    },
    getMoreCustomers: function() {
      var vm = this;
      vm.getLoadUsers(function(users) {
        vm.offset += vm.limit + 1;
        vm.users = vm.users.concat(users);
      });
    },
    onFailLoad: function(index) {
      this.$set(
        this.users[index],
        "profile_pic",
        "/static/img/assets/livechat/profile.png"
      );
    },
    getFormatDate: function(date, format) {
      return moment(date).format(format);
    },
    onActiveStartDate: function(value) {
      var vm = this;
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value;
      }
      this.filter.activeDate.start = value;
    },
    onActiveEndDate: function(value) {
      var vm = this;
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value;
      }
      this.filter.activeDate.end = value;
    },
    onRegisterStartDate: function(value) {
      var vm = this;
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value;
      }
      this.filter.registerDate.start = value;
    },
    onRegisterEndDate: function(value) {
      var vm = this;
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value;
      }
      this.filter.registerDate.end = value;
    },
    getIntent: function(callback) {
      let vm = this;
      let auth = null;
      let data = {
        pageid: vm.pageid
      };
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error);
          return;
        }
        if (response.data) {
          var isFoundDefault = false;
          $.each(response.data, function(index, val) {
            var intent = val;
            intent.isShow = false;
            vm.intents.push(intent);
          });
        }
        callback();
      });
    },
    exportCustomer: function(){
      let vm = this
      let csvContent = "";
      if (vm.loading) {
        return false
      }
      
      csvContent += "Name,Channel,Gender,Register Date,Last Active Date"  ;

      if (vm.$store.getters.getPackage == 'premium') {
        csvContent += ",Email,Phone No,Status,Message Sent"
      }

      csvContent += ",Locale"

      if (vm.$store.getters.getPackage == 'premium') {
        csvContent += ",Intent"
      }

      csvContent += "\r\n"


      $.each(vm.users,function(index,val){
          let row = ""

          row += '"' + ((val.first_name ? val.first_name : '') + ' ' + (val.last_name ? val.last_name : '')).replace(/\r?\n|\r/g, " / ") + '",'
          row += '"' + val.app + '",'
          row += '"' + val.gender + '",'
          row += '"' + (val.registertimestamp ? moment(val.registertimestamp).format('DD/MM/YYYY') : '-') + '",'
          row += '"' + (val.timestamp ? moment(val.timestamp).format('DD/MM/YYYY') : '-') + '",'
          if (vm.$store.getters.getPackage == 'premium') {
            row += '"' + (val.email ? val.email : '').replace(/\r?\n|\r/g, " / ") + '",'
            row += '"' + (val.phoneno ? val.phoneno : '').replace(/\r?\n|\r/g, " / ") + '",'
            row += '"' + (val.status ? val.status : '').replace(/\r?\n|\r/g, " / ") + '",'
            row += '"' + (val.messagesent ? val.messagesent : '') + '",'
            
          }
          row += '"'
          config.locale.find(function(locale){
              if(val.locale == locale.value){
                  row += locale.title 
                  return false
              }
          })
          row += '",'
          if (vm.$store.getters.getPackage == 'premium') {
            row += '"' + (val.intentlist ? val.intentlist.join(',') : '') + '"'
          }
          
          csvContent += row + "\r\n";
      })

      vm.exportCsv(csvContent, "customer")
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      let vm = this;
      if (newVal != oldVal) {
        vm.$emit("onUserLoaded", vm.count);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Customers.vue